module.exports = __webpack_public_path__ + "img/bonaire.bae8f921.png";